export default "__VITE_ASSET__95cc4015__"